// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"0b310091","999":"8ae99eca"}[chunkId] + ".chunk.js";
};